export default __webpack_public_path__ + "static/media/Link2.f130ce97.svg";